<template>
	<module-field :bind="$props" v-show="isSuper">
		<span class="input-box">
			<input type="text" v-model="inputVal" :placeholder="field.placeholder">
		</span>
	</module-field>
</template>

<script>
import CrudField from '@/mixins/CrudField';

export default {

	mixins: [ CrudField ],

	mounted() {
		if (!this.isSuper) {
			this.rules = {};
		}
	}
};
</script>
